import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
    methods: {
      exportPDF () {
        // eslint-disable-next-line new-cap
        const doc = new jsPDF({ orientation: 'landscape' })
        const svgElements = this.$refs.graphLegend.$refs.chartSvgs.querySelectorAll('svg')
        svgElements.forEach((item) => {
            item.setAttribute('width', item.getBoundingClientRect().width)
            item.setAttribute('height', item.getBoundingClientRect().height)
            item.style.width = null
            item.style.height = null
        })
        html2canvas(this.$refs.pdfExport, { scrollX: 0, scrollY: 0 })
          .then(function (canvas) {
            const width = doc.internal.pageSize.getWidth()
            const height = doc.internal.pageSize.getHeight()

            const widthRatio = width / canvas.width
            const heightRatio = height / canvas.height

            const ratio = widthRatio > heightRatio ? heightRatio : widthRatio

            doc.addImage(
              canvas.toDataURL('image/jpeg', 1.0),
              'JPEG',
              0,
              0,
              canvas.width * ratio,
              canvas.height * ratio,
            )
            doc.save('event-detail.pdf')
          })
      },
    },
}
